import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";

export default function ReligiousAffiliationTable({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(tbody || []);
  }, [tbody]);

  return (
    <div className="mc-table-responsive">
      <table className="mc-table">
        <thead className="mc-table-head">
          <tr>
            {thead.map((item, index) => (
              <th key={index}>{t(item)}</th>
            ))}
          </tr>
        </thead>

        <tbody className="mc-table-body even">
          {data?.map((item, index) => (
            <tr key={item.id || index}>

              {/* Sr. No */}
              <td>{index + 1}</td>

              {/* FSF ID */}
              <td>{item.f_number || "-"}</td>

             

              {/* Father / Guardian */}
              <td>{item.beneficiary_name || "-"}</td>

              {/* Faith */}
              <td>{item.faith_name || "-"}</td>

              {/* Prayer Place */}
              <td>{item.prayer_place || "-"}</td>

            
           

              {/* Actions */}
              <td>
                <div className="mc-table-action">

                  <Link
                    to={`/edit-religious-affiliation/${item.id}`}
                    className="material-icons edit"
                  >
                    edit
                  </Link>

                  <Link
                    to={`/religious-affiliation/${item.id}`}
                    className="material-icons visibility"
                  >
                    visibility
                  </Link>

                </div>
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}